import baseApi from './RootBaseApi';
import type {
  CreateEntitlementGrantPayload,
  EntitlementActorType,
  EntitlementGrantListResponse,
  EntitlementGrantResponse,
  ListEntitlementGrantsParams,
  UpdateEntitlementGrantPayload,
} from '@/types/entitlement-grant.types';

export const EntitlementGrantService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    listEntitlementGrants: builder.query<
      EntitlementGrantListResponse,
      ListEntitlementGrantsParams | void
    >({
      query: (params) => ({
        url: '/admin/entitlement-grants',
        method: 'GET',
        params: params ?? {},
      }),
      providesTags: ['EntitlementGrants'],
    }),

    getEntitlementGrant: builder.query<EntitlementGrantResponse, string>({
      query: (id) => ({
        url: `/admin/entitlement-grants/${id}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, id) => [{ type: 'EntitlementGrants', id }],
    }),

    getActiveEntitlementGrantsForActor: builder.query<
      EntitlementGrantListResponse,
      { actorType: EntitlementActorType; actorId: string }
    >({
      query: ({ actorType, actorId }) => ({
        url: `/admin/entitlement-grants/actor/${actorType}/${actorId}/active`,
        method: 'GET',
      }),
      providesTags: ['EntitlementGrants'],
    }),

    createEntitlementGrant: builder.mutation<
      EntitlementGrantResponse,
      CreateEntitlementGrantPayload
    >({
      query: (payload) => ({
        url: '/admin/entitlement-grants',
        method: 'POST',
        data: payload,
      }),
      invalidatesTags: ['EntitlementGrants'],
    }),

    updateEntitlementGrant: builder.mutation<
      EntitlementGrantResponse,
      { id: string; payload: UpdateEntitlementGrantPayload }
    >({
      query: ({ id, payload }) => ({
        url: `/admin/entitlement-grants/${id}`,
        method: 'PATCH',
        data: payload,
      }),
      invalidatesTags: ['EntitlementGrants'],
    }),
  }),
});

export const {
  useListEntitlementGrantsQuery,
  useGetEntitlementGrantQuery,
  useGetActiveEntitlementGrantsForActorQuery,
  useCreateEntitlementGrantMutation,
  useUpdateEntitlementGrantMutation,
} = EntitlementGrantService;
